module.exports = __webpack_public_path__ + "img/abstract_1.6abe64a0.png";